import { useRouter } from "next/router"
import styles from "./index.module.scss"
import { ApiUserData } from "src/models/user/ApiUserData"
import { useLocalStorage } from "react-use"
import routes from "routes"

type Props = {
  user: ApiUserData
}

const RewardRequestNotAuth: React.FC<Props> = ({ user }) => {
  const router = useRouter()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [redirectPage, setRedirectPage] = useLocalStorage<string>(
    "redirect_page",
    "",
  )

  const setPage = () => {
    setRedirectPage(routes.userRequest(user.display_name))
  }

  return (
    <div className={styles.rewardRequestNotAuth}>
      <h3 className={styles.rewardRequestNotAuth_title}>
        会員登録を行うとクリエイターへ制作を依頼することができます。
      </h3>
      <p className={styles.rewardRequestNotAuth_text}>
        クリエイターへの支援とともに、依頼を送ってみましょう。
        <br />
        たいあっぷギフトを贈ることでほしいものを依頼することができます。
      </p>

      <div className={styles.rewardRequestNotAuth_buttons}>
        <button
          className={`c-button-secondary ${styles.rewardRequestNotAuth_register}`}
          onClick={() => {
            setPage()
            router.push(routes.authSignUp())
          }}
        >
          新規登録
        </button>
        <p className={styles.rewardRequestNotAuth_login}>
          すでにアカウントをお持ちの方は
          <button
            className={styles.rewardRequestNotAuth_login_anchor}
            onClick={() => {
              setPage()
              router.push(routes.authSignIn())
            }}
          >
            ログインページへ
          </button>
        </p>
      </div>
    </div>
  )
}

export default RewardRequestNotAuth
